<template>
    <div id="login">
        <div class="login-register-wrapper">
            <div class="login-box">
                <div class="component-heading login-heading">ZALOGUJ SIĘ ABY UMÓWIĆ WIZYTĘ</div>
                <input class="input-default input-username" type="text"
                       placeholder="Wpisz login..." v-model="credentials.username">
                <input class="input-default input-password" type="password"
                       placeholder="Wpisz hasło..." v-model="credentials.password">
                <div class="credentials-submit-wrapper">
                    <div class="password-recovery-box">
                        <div>Nie pamiętasz hasła?</div>
                        <router-link :to="{name: 'password-recovery'}" class="password-recovery-link">
                            Odzyskaj hasło
                        </router-link>
                    </div>
                    <button class="btn-solid-blue btn-component" @click="login">ZALOGUJ SIĘ</button>
                </div>
            </div>
            <div class="register-box">
                <div class="component-heading register-heading">ZAREJESTRUJ SIĘ</div>
                <p class="register-prompt"> Dzięki rejestracji w sytemie dr100 będziesz mógł wygodnie umawiać się
                    on-line na wizyty stomatologiczne oraz będziesz miał wgląd w historię swoich danych medycznych</p>
                <router-link class="btn-solid-green btn-component btn-register"
                             :to="{name: 'registration'}" tag="button">REJESTRACJA</router-link>
            </div>
        </div>
        <free-term v-if="freeTerm" :free-term="freeTerm" :type="TYPES.CHOSEN"></free-term>
    </div>
</template>

<style lang="scss" scoped>
@import "../../css/constants.scss";

$login-color: #4d84b9;
$register-color: #4fb696;

#login {
    min-height: $bg-min-height;

    .login-register-wrapper {
        display: flex;
        flex-flow: row;
        width: fit-content;
        width: -moz-max-content;
        margin-left: auto;
        margin-right: auto;

        .login-box {
            display: flex;
            flex-flow: column;

            .login-heading {
                color: $login-color;
            }
            .input-username {
                padding-left: 45px;
                background: white url('../../images/username-icon.png') no-repeat 10px 50%;
            }
            .input-password {
                padding-left: 45px;
                background: white url('../../images/password-icon.png') no-repeat 10px 50%;
            }
            .credentials-submit-wrapper {
                display: flex;

                .password-recovery-box {
                    font-size: 12px;
                    font-style: italic;
                    text-align: left;
                    margin-right: auto;
                    color: $login-color;

                    .password-recovery-link {
                        font-weight: 600;
                        text-decoration: underline;
                        color: $login-color;
                    }
                }
            }
        }
        .register-box {
            margin-left: 3em;

            .register-heading {
                color: $register-color;
            }
            .register-prompt {
                width: 265px;
                font-weight: bold;
                padding-left: 0.2em;
                color: $register-color;
            }
            .btn-register {
                margin-top: 4px;
            }
        }
        .btn-component {
            font-size: 17px;
            font-weight: bold;
            min-width: 160px;
        }
        .component-heading {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 0.8em;
        }
    }
    .free-term {
        margin-top: 2.5em;
        margin-left: auto;
        margin-right: auto;
    }
    @media all and (max-width: 670px) {

        .login-register-wrapper {
            flex-direction: column;

            .register-box {
                margin-top: 2em;
                margin-left: 0;

                .register-prompt {
                    text-align: justify;
                    width: initial;
                }
                .btn-register {
                    float: right;
                }
            }
        }
    }
}
</style>

<script>
import FreeTerm from './FreeTerm.vue'
import ApiMixin from '../mixins/ApiMixin.js'

import {
    FREE_TERM_TYPES as TYPES,
} from '../constants.js'

export default {
    name: 'Login',
    components: {
       FreeTerm,
    },
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            credentials: {
                username: '',
                password: '',
            },

            TYPES: TYPES,
        }
    },
    computed: {
        freeTerm() {
            return this.$store['FreeTerm-chosenFreeTerm'];
        },
    },
    methods: {
        login() {
            if (!this.credentials.username || !this.credentials.password) {
                this.showAllCredentialsRequiredAlert();
                return;
            }

            this.$http.post(this.$api.login(), this.credentials).then(response => {
                this.$bus.$emit('$store:setPatient', response.data);
                this.$bus.$emit('$store:setIsPatientLoggedIn', true);
                this.$router.push({name: 'free-term-confirmation', params: {freeTerm: this.freeTerm}});
            }, response => {
                if (response.status === 401) {
                    this.$app.showFailureAlert(response.body.detail);
                } else if (response.status === 400) {
                    this.showAllCredentialsRequiredAlert();
                }
            });
        },
        showAllCredentialsRequiredAlert() {
            this.$app.showFailureAlert('Login i hasło są wymagane.');
        },
    },
    mounted() {
        // Custom warning -> perhaps unnecessary if login with no free term chosen will be available.
        setTimeout(() => {
            const text = `[Login.vue] Hola Amigo! Variable this.freeTerm is null! So the FreeTerm.vue component ` +
                `at the bottom of the page wouldn't be rendered! Check what's going on mate!`;
            if (!this.freeTerm) console.warn(text);
        }, 100);
    },
}
</script>



// WEBPACK FOOTER //
// Login.vue?5f7c1fad